import { render, staticRenderFns } from "./AuditLogSetupListing.vue?vue&type=template&id=a53369a8"
import script from "./AuditLogSetupListing.vue?vue&type=script&lang=js"
export * from "./AuditLogSetupListing.vue?vue&type=script&lang=js"
import style0 from "./AuditLogSetupListing.vue?vue&type=style&index=0&id=a53369a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports